/**
 * High level router.
 *
 * Note: It's recommended to compose related routes in internal router
 * components (e.g: `src/pages/auth/AuthPage`, `src/pages/home/HomePage`).
 */

import React, { lazy, Suspense } from "react";
import { Switch, Route, BrowserRouter } from "react-router-dom";
import { LayoutSplashScreen } from "../../_metronic";

const LandingPagePage = lazy(() => import("../pages/landing-page/LandingPagePage"));

export const Routes = () => {
    return (
        <Suspense fallback={<LayoutSplashScreen />}>
            <BrowserRouter>
                <Switch>
                    <Route path="/:uuid?" component={LandingPagePage} />
                </Switch>
            </BrowserRouter>
        </Suspense>
    );
};
